/**
 * The two tabs of the manage bank & credit card accounts page, and the route
 * params that drive them. They live beside the feature set rather than on the
 * page (modules/accounts-payable) so that this platform package does not
 * import a module; the page re-exports them for its route typing.
 */
export const ManageBankCreditCardAccountsTabs = {
  ACCOUNTS: 'accounts',
  CREDIT_CARDS: 'creditcards',
} as const

export interface ManageBankCreditCardAccountsParams {
  status: string
}
